import { ComponentProps } from "react";

type DoneConfirmProps = {} & ComponentProps<"button">;

export function DoneConfirm({ onClick }: DoneConfirmProps) {
  return (
    <>
      <input type="checkbox" id="qcDoneModal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">اتمام بررسی</h3>
          <p className="py-4">آیا از اتمام بررسی این فیلم مطمئن هستید؟</p>
          <div className="modal-action">
            <div className="flex w-full justify-between mt-10">
              <label
                htmlFor="qcDoneModal"
                className="btn btn-error btn-outline px-10"
              >
                خیر
              </label>
              <button className="btn btn-info px-10" onClick={onClick}>
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
